import { Pipe, type PipeTransform } from '@angular/core';
import { columnsSort } from '../helper/columns-sort.util';

@Pipe({
    name: 'listBreakpointSort',
})
export class ListBreakpointSortPipe implements PipeTransform {
    public transform<T>(value: T[] | undefined, isMobile: boolean): T[] {
        if (!Array.isArray(value)) {
            return [];
        }

        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        if (value.length <= 2 || isMobile) {
            return value;
        }

        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        return columnsSort(value, 2);
    }
}
